import {landingConstants} from "../constants/landingConstants";

const initialState = {
    data: {
        records: [],
        page: 0,
        recordsPerPage: 0,
        total: {}
    },
    errorMsg: "",
    isLoading: false,
    name: "",
    tags: [],
    orderBy: "",
    sortBy: "",
    sortColumns: [],
    rerender: false
};

const landingReducer = (state = initialState, action) => {
    switch (action.type) {
        case landingConstants.LANDINGS_LOADING_SPINNER:
            return {
                ...state,
                isLoading: true,
            };
        case landingConstants.LANDINGS_STOP_LOADING_SPINNER:
            return {
                ...state,
                isLoading: false,
            };
        case landingConstants.LANDINGS_INFINITY_SCROLL:
            return {
                ...state,
                data: {
                    records: [...state.data.records, ...action?.result?.records],
                    page: action?.result?.page,
                    recordsPerPage: action?.result?.recordsPerPage,
                    total: action?.result?.total
                },
                errorMsg: '',
                isLoading: false
            };
        case landingConstants.LANDINGS_GET_DATA:
            return {
                ...state,
                data: {
                    records: action?.result?.records,
                    page: action?.result?.page,
                    recordsPerPage: action?.result?.recordsPerPage,
                    total: action?.result?.total
                },
                errorMsg: '',
                isLoading: false,
                rerender: false
            };
        case landingConstants.LANDINGS_ERROR:
            return {
                ...state,
                errorMsg: 'Unable to load landings. Please try again.',
                rerender: false,
                isLoading: false,
            };
        case landingConstants.LANDINGS_ARCHIVE:
            return {
                ...state,
                rerender: true,
                isLoading: false,
            };
        case landingConstants.LANDINGS_RESTORE:
            return {
                ...state,
                rerender: true,
                isLoading: false,
            };
        case landingConstants.LANDINGS_UPDATE_ORDER_BY:
            return {
                ...state,
                orderBy: action.orderBy
            };
        case landingConstants.LANDINGS_UPDATE_SORT_BY:
            return {
                ...state,
                sortBy: action.sortBy
            };
        case landingConstants.LANDINGS_UPDATE_NAME:
            return {
                ...state,
                name: action.name
            };
        case landingConstants.LANDINGS_UPDATE_TAGS:
            return {
                ...state,
                tags: action.tags
            };
        case landingConstants.LANDINGS_UPDATE_SORT_COLUMNS:
            return {
                ...state,
                sortColumns: action.sortColumns
            };
        case landingConstants.LANDINGS_RERENDER:
            return {
                ...state,
                rerender: true
            };
        case landingConstants.BULK_UPDATE_CHANGE_WORKSPACE:
            return {
                ...state,
                rerender: true,
                isLoading: false,
            };
        case landingConstants.LANDINGS_BULK_UPDATE_FOR_URL:
            return {
                ...state,
                rerender: true,
                isLoading: false,
            };
        default:
            return state;
    }
};

export default landingReducer;